
class SignTarget {
  code: string;
  text: string;
  needTributaryID: boolean;
  value: boolean;

  static parseList(raw?: any): SignTarget[] {
    let list: SignTarget[] = [];
    if (raw && Array.isArray(raw)) {
      for (let item of raw) {
        const target: ?SignTarget = SignTarget.parse(item);
        if (target) {
          list.push(target);
        }
      }
    }
    return list;
  }

  static parse(raw: any): ?SignTarget {
    if (raw) {
      const target = new SignTarget();
      target.copyFrom(raw);
      return target;
    }
  }

  copyFrom(raw: any) {
    this.code = raw.code;
    this.text = raw.text;
    this.needTributaryID = raw.needTributaryID;
    this.value = raw.value;
  }
}

export default SignTarget;
